import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Group } from "@shared/models/group"
import groupChangeBrandingAction from "cc-frontend/lib/actions/group/GROUP_CHANGE_BRANDING"
import groupChangeTitleAction from "cc-frontend/lib/actions/group/GROUP_CHANGE_TITLE"
import type Dispatcher from "cc-frontend/services/dispatcher"
import type Filestack from "cc-frontend/services/filestack"
import type ModalManager from "cc-frontend/services/modal-manager"
import { task, timeout } from "ember-concurrency"
import { merge } from "lodash-es"
import { tracked } from "tracked-built-ins"

export interface SchoolEditNameSignature {
  Args: {
    model: {
      group: Group
    }
    order: number
    closeModal: () => {}
  }
}

export default class SchoolEditName extends Component<SchoolEditNameSignature> {
  @service declare dispatcher: Dispatcher
  @service declare modalManager: ModalManager
  @service declare filestack: Filestack

  @tracked isUploadingFile = false

  changeColor = task({ keepLatest: true }, async (type, color) => {
    let branding = merge({}, this.args.model.group.attributes.branding, { [type]: color })
    this.dispatcher.dispatchPreparedAction(
      groupChangeBrandingAction({
        groupId: this.args.model.group.id,
        value: branding,
        originalValue: this.args.model.group.attributes.branding,
      })
    )
    await timeout(500)
  })

  @action
  setTitle(title) {
    this.dispatcher.dispatchPreparedAction(
      groupChangeTitleAction({
        groupId: this.args.model.group.id,
        value: title,
        originalValue: this.args.model.group.attributes.title,
      })
    )
  }

  @action
  setLogo() {
    let picker = this.filestack.client.picker({
      accept: "image/*",
      fromSources: [
        "local_file_system",
        "url",
        "googledrive",
        "dropbox",
        "onedrive",
        "onedriveforbusiness",
        "clouddrive",
        "gmail",
        "facebook",
        "instagram",
      ],
      imageMin: [512, 512],
      imageMax: [512, 512],
      imageDim: [512, 512],
      transformations: {
        crop: {
          force: false,
        },
        rotate: true,
      },
      maxFiles: 1,
      onUploadDone: (res) => {
        this.isUploadingFile = true
        this.filestack.client
          .storeURL(
            this.filestack.client.transform(res.filesUploaded[0].url, {
              resize: { height: 128, width: 128 },
              output: { format: "png" },
            })
          )
          .then((transformRes: any) => {
            this.dispatcher.dispatchPreparedAction(
              groupChangeBrandingAction({
                groupId: this.args.model.group.id,
                value: {
                  primaryColor: this.args.model.group.attributes.branding.primaryColor,
                  secondaryColor: this.args.model.group.attributes.branding.secondaryColor,
                  fileStackHandle: res.filesUploaded[0].handle,
                  fileStackHandleSmall: transformRes.handle,
                },
                originalValue: this.args.model.group.attributes.branding,
              })
            )
            this.isUploadingFile = false
          })
      },
    })
    picker.open()
  }

  @action
  setColor(type, color) {
    this.changeColor.perform(type, color)
  }
}
